import { Component, Input, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ClientsService } from '../../../../../../services/clients.service';

@Component({
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: 'clients-activity-list',
    templateUrl: './activity-list.component.html',
    styleUrls: ['./activity-list.component.scss']
})
export class ActivityListComponent implements OnInit {
    @Input() data;
  
    dtConfig = {
        config: {
            base: this.clientService,
            api: 'activityList',
            rowsPerPage: 10,
            order: [[2, 'desc']],
            params: {
                mac: ''
            }
        },
        columns: [
            {
                title: 'Fecha',
                field: 'date'
            },
            {
                title: 'Router',
                field: 'box'
            },
            {
                title: 'URL',
                field: 'url'
            }
        ],
        actions: []
    };

    constructor(
        public modalRef: BsModalRef,
        public clientService: ClientsService
    ) { }

    ngOnInit(): void {
        this.dtConfig.config.params.mac = this.data.mac;
    }
}
